import { useRef, useState } from "react";
import { Play } from "lucide-react";

export const LandingVideo = () => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlay = () => {
        if (videoRef.current) {
            videoRef.current.play();
            setIsPlaying(true);
        }
    };

    return (
        <section className="pt-4 pb-10 md:pt-8 md:pb-12 bg-white">
            <div className="container mx-auto px-4">

                {/* Heading */}
                <div className="text-center max-w-2xl mx-auto mb-12">
                    <div className="inline-flex items-center gap-2 bg-primary/8 text-primary text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
                        ⚡ See It In Action
                    </div>
                    <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                        Start your giveaway in under 45 seconds.
                    </h2>
                    <p className="text-lg text-gray-500">
                        No tutorials needed. No complicated setup.
                        Watch the full flow from signup to live contest.
                    </p>
                </div>

                {/* Video Container */}
                <div className="relative max-w-3xl mx-auto rounded-2xl overflow-hidden shadow-xl border border-gray-100 bg-gray-950 group">
                    <video
                        ref={videoRef}
                        src="https://ik.imagekit.io/ez0lwy8fc/_RaffleKit/rafflekit-demo-video.mp4"
                        className="w-full h-auto block"
                        controls={isPlaying}
                        playsInline
                        preload="metadata"
                        onEnded={() => setIsPlaying(false)}
                    />

                    {/* Play Overlay — hidden once playing */}
                    <div
                        className="absolute inset-0 flex items-center justify-center cursor-pointer bg-black/30 transition-opacity duration-200 group-hover:bg-black/40"
                        onClick={handlePlay}
                        role="button"
                        aria-label="Play demo video"
                        style={{
                            opacity: isPlaying ? 0 : 1,
                            pointerEvents: isPlaying ? 'none' : 'auto',
                            transition: 'opacity 0.2s ease',
                        }}
                    >
                        <div
                            className="rounded-full bg-white/95 flex items-center justify-center shadow-2xl hover:scale-105 transition-transform duration-150"
                            style={{ width: 72, height: 72 }}
                        >
                            <Play className="w-7 h-7 text-primary fill-primary ml-1" />
                        </div>
                    </div>
                </div>

                {/* Subtle subtext below video */}
                <p className="text-center text-sm text-gray-400 mt-5">
                    Full demo · No voiceover · Real product
                </p>

            </div>
        </section>
    );
};
